module.exports = __webpack_public_path__ + "img/logoLp.b4bac305.png";